import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

import Menu from 'src/app/modules/_models/menu.model';
import { FidelidadeService } from 'src/app/modules/_services/fidelidade.service';
import { NavigationService } from 'src/app/modules/_services/navigation.service';
import { environment } from '../../../../../environments/environment';
import { LocalStorageUtils } from '../../../../utils/localstorage';
import { CookieService } from '../../../_services/cookie.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
  exibeDesconectar: boolean = false;
  exibir: boolean = false;

  exibePopupGenerico: boolean = false;
  tituloModalGenerico: string = '';
  descricaoModalGenerico: string[] = [];

  exibirLoader: boolean = false;

  paginaAtual: Menu;

  appOnly: boolean = false;

  coresPalitoPremiado: boolean = false;

  currentRoute: string;

  public LocalStorage = new LocalStorageUtils();

  constructor(
    private fidelidadeService: FidelidadeService,
    private router: Router,
    private navigationService: NavigationService,
    private cookieServeice: CookieService
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const href = event.urlAfterRedirects.trim();
        this.paginaAtual = this.navigationService.obterPaginaPorLink(href);

        if (this.paginaAtual.link === '/palito-premiado') {
          this.coresPalitoPremiado = true;
        } else {
          this.coresPalitoPremiado = false;
        }
        this.exibir = this.paginaAtual.footer.exibir;
      }

      // this.router.events.subscribe((event) => {
      //   if (event instanceof NavigationEnd) {
      //     this.currentRoute = this.router.url;

      //   }
      // });
    });
  }

  ngOnInit(): void {
    this.fidelidadeService.eventTriggerTermo$.subscribe(() => {
      this.mostrarPopupTermos();
    });
    this.fidelidadeService.eventTriggerRegulamento$.subscribe(() => {
      this.mostrarPopupRegulamento();
    });
    if (this.fidelidadeService.LocalStorage.obterSessaoApp()) {
      this.appOnly = true;
    } else {
      this.appOnly = false;
    }
  }

  // desconectar(): void {
  //   this.authService.LocalStorage.desconectar();
  //   this.router.navigate(['/']);
  // }

  // popupSac() {
  //   this.router.navigate([]).then((result) => {
  //     window.open('atendimento', '_blank');
  //   });
  // }

  // ** EVENTOS DE TELA ** //

  public mostrarPopupTermos() {
    this.limparDescricao();
    this.exibirLoader = true;

    this.fidelidadeService.obterConfiguracaoPorDescricao('termos').subscribe(
      (sucesso) => {
        this.processarSucessoTermos(sucesso);
      },
      (falha) => {
        this.processarFalhaTermos(falha);
      }
    );
  }

  public mostrarPopupRegulamento(regulamento: string = 'regulamento') {
    this.limparDescricao();
    this.exibirLoader = true;

    this.fidelidadeService
      .obterConfiguracaoPorDescricao(regulamento)
      .subscribe(
        (sucesso) => {
          this.processarSucessoRegulamento(sucesso);
        },
        (falha) => {
          this.processarFalhaRegulamento(falha);
        }
      );
  }

  sendMemberCookie() {
    const user = this.LocalStorage.obterMembro();

    if (user) {
      let telefoneTratado;
      if (user.telefone != null) {
        let tel = user.telefone;
        telefoneTratado = tel.replace('55', '', 1);
      }
      const cookie = {
        nome: user.nome,
        cpf: user.cpf,
        email: user.email,
        telefone: telefoneTratado,
      };

      this.cookieServeice.setSecureCookie('_fidelity', cookie);
    }
  }

  handleGoToSac() {
    this.sendMemberCookie();
    window.location.href = `${environment.urlSac}#Atendimento`;
  }

  handleGoToSacCacaulovers() {
    this.sendMemberCookie();
    window.location.href = `${environment.urlSac}cacaulovers`;
  }

  public irPara(link: string, linkExterno: boolean) {
    this.navigationService.irParaPorLink(link, linkExterno);
  }

  public irParaEcommerce(): void {
    this.fidelidadeService.redirecionarEcommerce().subscribe();
  }

  // ** METODOS PRIVADOS DE SUCESSO E INSUCESSO ** //
  private processarSucessoTermos(response: any) {
    let linhas = response.valor.split('\n');

    for (let index = 1; index < linhas.length; index++) {
      if (linhas[index] == '\r') continue;

      this.descricaoModalGenerico.push(`${linhas[index]}<br><br>`);
    }

    this.exibirLoader = false;

    this.exibePopupGenerico = true;
    this.tituloModalGenerico = linhas[0];
  }

  private processarFalhaTermos(fail: any) {
    this.exibirLoader = false;
    console.error('Ocorreu um erro ao tentar obter o termo', fail);
  }

  private processarSucessoRegulamento(response: any) {
    var linhas = response.valor.split('\n');

    for (let index = 1; index < linhas.length; index++) {
      if (linhas[index] == '\r') continue;

      this.descricaoModalGenerico.push(`${linhas[index]}<br><br>`);
    }

    this.exibirLoader = false;
    this.exibePopupGenerico = true;
    this.tituloModalGenerico = linhas[0];
  }

  private processarFalhaRegulamento(fail: any) {
    this.exibirLoader = false;
    console.error('Ocorreu um erro ao tentar obter o regulamento', fail);
  }

  // ** METODOS PRIVADOS DE APOIO ** //
  private limparDescricao() {
    this.descricaoModalGenerico = [];
  }

  public irParaHome(): void {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }
}
